import Title from "./components/Title/Title";
import Paragraph from "./components/Paragraph/Paragraph";
import Button from "./components/Button/Button";
import OptionsItem from "./components/OptionsItem/OptionsItem";
import React, { useEffect, useState } from "react";
import imageStartScreen from "./assets/images/00.webp";
import imageResult from "./assets/images/9.webp";
import styles from "./App.module.scss";
import questions from "./state/questions";
import classNames from "classnames";
import Result from "./components/Result/Result";

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0); // считаем номер вопроса
  const [stateFlow, setStateFlow] = useState("Start"); // состояние флоу: стартовый экран / вопросы / результат
  const [option, setOption] = useState(false); // выбран ли ответ
  const [resultState, setResultState] = useState(""); // выводить ли результат
  const [resultCount, setResultCount] = useState(0); // счетчик правильных вопросов
  const phone = document.getElementById("phone"); // находим область телефона на десктопе

  // console.log(resultCount); // тестирование логики

  // прокрутка вниз при нажатии на ответ
  const optionActiveHandler = (option) => {
    setOption(option);

    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: "smooth" });
      phone.scrollTo({ top: 1000, behavior: "smooth" });
    }, "50");
  };

  const resultCountLogic = (result) => {
    setResultCount(resultCount + result);
  };

  // поднимаемся наверх после перехода на страницу
  const scrollReset = (event) => {
    window.scrollTo(0, 0);
    phone.scrollTo(0, 0);
  };

  // Скролл наверх при нажатии старт квиз
  const startFlow = () => {
    setStateFlow("Flow");
    window.scrollTo(0, 0);
  };

  // логика флоу
  const handlerNext = () => {
    if (currentQuestion === 4) {
      setStateFlow("End");

      setResultState(() => {
        if (resultCount >= 1) {
          return (
            <Result
              score={resultCount + " câu trả lời đúng"}
              title="Bạn vẫn còn nhiều điều để khám phá về xu hướng thời trang. Vậy thì đừng lãng phí thời gian nữa bạn nhé!"
              text={
                "Nhanh tay kích hoạt mã giảm giá và chọn các sản phẩm thương hiệu của dịch vụ. Bạn sẽ nhận được giảm giá 10% khi mua đồng phục Maxim. Khám phá ngay các món đồ độc đáo tại cửa hàng Shopee 👈"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 2 && resultCount <= 3) {
          return (
            <Result
              score={resultCount + " câu trả lời đúng"}
              title="Thời trang luôn thay đổi, và bạn gần như đã bắt kịp rồi. Đừng bỏ lỡ nhé!"
              text={
                "Mã giảm giá tặng bạn 10% khi mua đồng phục Maxim. Hãy chọn các sản phẩm chính hãng trên Shopee 👈 Luôn dẫn đầu xu hướng!"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 4 && resultCount <= 5) {
          return (
            <Result
              score={resultCount + " câu trả lời đúng"}
              title="Có vẻ như bạn thật sự là người am hiểu xu hướng thời trang! Chúng tôi nhất định sẽ xin lời khuyên từ bạn khi tạo bộ sưu tập mới."
              text={
                "Còn bây giờ, hãy nhận ngay quà tặng là mã giảm giá bạn nhé. Đây là mã giảm giá 10% khi mua đồng phục Maxim. Sử dụng mã giảm giá để chọn cho mình những món đồ độc đáo của dịch vụ tại Shopee 👈"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }
      });

      // сбрасываем  скролл для результата
      scrollReset();
    } else {
      setOption(false);
      setCurrentQuestion(currentQuestion + 1);

      // прокрутка вверх после нажатия на ответ
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        phone.scrollTo({ top: 0, behavior: "smooth" });
      }, "50");
    }
  };

  // возвращение в начало
  const handlerBack = () => {
    setOption(false);
    setStateFlow("Start");
    setCurrentQuestion(0);
    setResultCount(0);
  };

  // считаем цифры прокрутки и верешаем options::after
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.wrapper}>
        <div className={styles.phone} id="phone">
          {stateFlow === "Start" ? (
            <>
              <div className={styles.posterContainer}>
                <img src={imageStartScreen} className={styles.image} alt="" />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.contentWrapper}>
                    <Title value="Giảm giá gần trong tầm tay: kiểm tra kiến thức về những điều thường ngày và nhận quà tặng" />
                    <Paragraph value="Có đúng là mũ bảo hiểm đã tồn tại hơn 100 năm và áo dài tay ban đầu đều có màu trắng không? Hãy trả lời 5 câu hỏi và kiểm tra kiến thức của bạn nhé." />
                    <Paragraph value="Quà tặng đang chờ bạn ở cuối bài, là mã giảm giá khi mua hàng chính hãng từ maxim!" />
                    <Paragraph value="Tất cả sản phẩm mới và đồng phục được yêu thích đều đã có mặt trên Shopee 👈" />
                  </div>
                  <Button
                    value="Bắt đầu"
                    onClick={() => startFlow()}
                    id="start"
                  />
                </div>
              </div>
            </>
          ) : stateFlow === "Flow" ? (
            <>
              <div className={styles.posterContainer}>
                <img
                  src={questions[currentQuestion].image}
                  className={styles.image}
                  alt={questions[currentQuestion].image}
                />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.header}>
                    <div className={styles.topBarContainer}>
                      <div>
                        Câu hỏi {currentQuestion + 1} trên {questions.length}
                      </div>
                    </div>
                    <div>
                      <div className={styles.headerDesc}>
                        <Title
                          value={questions[currentQuestion].questionDesc}
                        />
                      </div>
                    </div>
                    <Title value={questions[currentQuestion].questionText} />
                  </div>

                  <div className={styles.optionsWrapper}>
                    {questions[currentQuestion].answerOptions.map((item) => (
                      <OptionsItem
                        key={item.answerText}
                        title={item.answerText}
                        resultText={item.answerResult}
                        onClick={optionActiveHandler}
                        disabled={option}
                        result={item.result}
                        resultCountLogic={resultCountLogic}
                      />
                    ))}
                  </div>

                  <Button
                    value="Tiếp"
                    onClick={() => handlerNext()}
                    disabled={!option}
                    id={"btn" + (currentQuestion + 1)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>{resultState}</>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
